import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { primarycolor } from '../../utils/colors';
import ReactLoading from 'react-loading';
import { Container, Modal } from '@mui/material';
import ReactCodeInput from 'react-verification-code-input';
import fetch from '../../utils/fetch';


let color = "white";
let type = "spokes";


export default function SignUp({ successsignup, onshowlogin, ondismiss }) {
    const [error, seterror] = useState('');
    const [progress, setprogress] = useState(false);
    const [success, setsuccess] = useState('');

    const [code, setcode] = useState(0);

    const [gottendata, setgottendata] = useState('');

    const [showsignup, setshowsignup] = useState(true);

    const handleSubmit = (event) => {
        setprogress(true)
        seterror(null)
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const email = data.get('email')
        const password = data.get('password')
        const firstName = data.get('firstName')
        const lastName = data.get('lastName')
        const phone = data.get('phone');


        if (!email || !password || !firstName || !lastName || !phone) {
            seterror("Fill all fields")
            setprogress(false)
        } else {
            seterror(null)
            fetch.get('requestCustomerAccount', {
                username: firstName + " " + lastName,
                email: email,
                phone: phone,
                password: password,
            }).then(response => {
                setprogress(false)
                if (!response.data.message) {
                    if (response.data.success) {
                        setgottendata(response.data)
                        setshowsignup(false)
                    } else {
                        seterror("there was an internal error contact admin")
                    }
                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setprogress(false)
                seterror("Sorry an error occurred,try again later");


            });
        }

    };

    //verify code
    const validatecode = (event) => {
        seterror(null)
        event.preventDefault()
        if (code == gottendata.code) {
            setsuccess('code validates sucessfully,redirecting,,,,')
            setTimeout(() => {
                successsignup()
            }, 3000);
        } else {
            seterror('invalid code')
        }
    }

    return (
        <Modal
            open={true}
            onClose={() => ondismiss()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Container component="main" maxWidth="xs" style={{ backgroundColor: "white", borderRadius: 20 }}>
                {showsignup ?
                    <Box
                        sx={{
                            marginTop: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Avatar sx={{ m: 1, bgcolor: primarycolor }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Sign up
                        </Typography>
                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        autoComplete="given-name"
                                        name="firstName"
                                        required
                                        fullWidth
                                        id="firstName"
                                        label="First Name"
                                        autoFocus
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        id="lastName"
                                        label="Last Name"
                                        name="lastName"
                                        autoComplete="family-name"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        fullWidth
                                        id="email"
                                        label="Email Address"
                                        name="email"
                                        autoComplete="email"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        fullWidth
                                        id="phone"
                                        label="Phone number"
                                        name="phone"
                                        autoComplete="phone-number"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                        id="password"
                                        autoComplete="new-password"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={<Checkbox value="allowExtraEmails" color="primary" />}
                                        label="Remember me."
                                    />
                                </Grid>
                            </Grid>
                            {error && <div style={{ fontSize: 10, color: "red" }}>{error}</div>}
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                {progress ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Sign Up"}
                            </Button>
                            <Grid container justifyContent="flex-end">
                                <Grid item>
                                    <Link to="" onClick={() => onshowlogin()} style={{ color: primarycolor, fontSize: 13 }} variant="body2">
                                        Already have an account? Sign in
                                    </Link>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box> :
                    <div style={{ marginTop: 30 }}><br /><br />
                        <div >Enter Code sent to {gottendata?.email}</div>
                        <Box component="form" onSubmit={validatecode} noValidate sx={{
                            marginTop: 8,
                        }}>
                            <ReactCodeInput
                                onChange={setcode}
                            />
                            {success && <div style={{ color: "green", fontSize: 10 }}>{success}</div>}
                            {error && <div style={{ color: "red", fontSize: 10 }}>{error}</div>}
                            <Button
                                type="submit"
                                fullWidth
                                style={{ backgroundColor: primarycolor }}
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                {progress ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Validate Code"}
                            </Button>
                        </Box>
                    </div>
                }
            </Container>
        </Modal>

    );
}